import { ArdoqId, ViewIds } from '@ardoq/api-types';
import { dispatchAction } from '@ardoq/rxbeach';
import {
  focusedComponentChanged,
  hoveredComponentChanged,
} from 'tabview/actions';
import {
  componentMatrixCollapseAllColumns,
  componentMatrixCollapseAllRows,
  componentMatrixExpandAllColumns,
  componentMatrixExpandAllRows,
} from './actions';
import { isPresentationMode } from 'env';
import { componentSelectedInPresentationMode } from 'streams/components/ComponentActions';

const VIEW_ID = ViewIds.COMPONENT_MATRIX;

const setHoveredItemState = (itemId: ArdoqId | null) => {
  dispatchAction(hoveredComponentChanged(itemId), VIEW_ID);
};

const setFocusedItemState = (itemId: ArdoqId | null) => {
  dispatchAction(focusedComponentChanged(itemId), VIEW_ID);
  // The handler ignores ids that aren't components, so list-value header ids
  // (dispatched from the row/column header cells) are safe no-ops.
  if (itemId && isPresentationMode()) {
    dispatchAction(componentSelectedInPresentationMode({ id: itemId }));
  }
};

const collapseAllRows = () => dispatchAction(componentMatrixCollapseAllRows());
const expandAllRows = () => dispatchAction(componentMatrixExpandAllRows());
const collapseAllColumns = () =>
  dispatchAction(componentMatrixCollapseAllColumns());
const expandAllColumns = () =>
  dispatchAction(componentMatrixExpandAllColumns());

export const componentMatrixCommands = {
  setHoveredItemState,
  setFocusedItemState,
  collapseAllRows,
  expandAllRows,
  collapseAllColumns,
  expandAllColumns,
};
